<mat-toolbar class="footer">
  <div class="footer-shell">
    <div class="footer-brand">
      <a [href]="env.urlBase || '/'" class="brand-link">
        <img src="/assets/img/logo-square.png" alt="belockey.com logo" class="logo">
        <div class="brand-copy">
          <strong>belockey.com</strong>
          <span>Gestion inteligente de reservas, taquillas y accesos.</span>
        </div>
      </a>
    </div>

    <div class="footer-card contact-section">
      <span class="section-overline">Contacto</span>
      <a class="contact-item" href="tel:+34614256641">
        <mat-icon>call</mat-icon>
        <span>614256641</span>
      </a>
      <a class="contact-item" href="mailto:contacta@belockey.com">
        <mat-icon>mail</mat-icon>
        <span>contacta@belockey.com</span>
      </a>
    </div>

    <div class="footer-card links-section">
      <span class="section-overline">Recursos</span>
      <a [href]="env.urlBase || '/'">Blog - English</a>
      <a [href]="env.urlBase || '/'">FAQ</a>
      <a [href]="env.urlBase || '/'">Terms and conditions of use</a>
      <a [href]="env.urlBase || '/'">Privacy policy</a>
      <a [href]="env.urlBase || '/'">Cookie policy</a>
    </div>
  </div>
</mat-toolbar>
